export const withoutCollapsedDescendants = <T extends { depth: number }>(
  rows: T[],
  isCollapsed: (row: T) => boolean,
): T[] => {
  const visible: T[] = [];
  let collapsedDepth: number | null = null;

  for (const row of rows) {
    if (collapsedDepth !== null && row.depth > collapsedDepth) {
      continue;
    }
    visible.push(row);
    collapsedDepth = isCollapsed(row) ? row.depth : null;
  }

  return visible;
};

export const nestedChildIds = <T extends { depth: number }>(
  rows: T[],
  idOf: (row: T) => string | undefined,
): Set<string> => {
  const ids = new Set<string>();
  for (let index = 0; index < rows.length - 1; index += 1) {
    const id = idOf(rows[index]);
    if (id && rows[index + 1].depth > rows[index].depth) {
      ids.add(id);
    }
  }
  return ids;
};
